
    // IMPORTS
    import { defineComponent, PropType, toRef } from 'vue'
    import { useScrollHint } from '@/composables/useScrollHint'
    import type { WatchSource } from 'vue'

    export default defineComponent({
        name: 'ScrollArrows',

        props: {
            containerRef: { type: [Object, null] as PropType<any>, required: true, default: null },
            scrollSelector: { type: String as PropType<string>, required: true },
            trigger: { type: null as unknown as PropType<unknown>, required: false, default: undefined }
        },

        setup(props) {
            const containerRefRef = toRef(props, 'containerRef')
            const triggerRef = toRef(props, 'trigger') as WatchSource

            const { showUpHint, showDownHint, upArrowTop, downArrowBottom, scrollUp, scrollDown } = useScrollHint(
                containerRefRef,
                props.scrollSelector,
                triggerRef
            )

            return { showUpHint, showDownHint, upArrowTop, downArrowBottom, scrollUp, scrollDown }
        }
    })
